import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface PlatformContent {
  platform: string;
  sub_platform: string;
  current_status: string;
  specific_issue: string;
  improvement_needed: string;
  priority: string;
  estimated_impact: string;
  ready_to_generate: boolean;
}

@Component({
  selector: 'app-platform-content-card',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './platform-content-card.component.html',
  styleUrl: './platform-content-card.component.scss'
})
export class PlatformContentCardComponent {
  @Input() platform!: PlatformContent;
  @Output() generateContent = new EventEmitter<PlatformContent>();

  onGenerateClick(): void {
    this.generateContent.emit(this.platform);
  }
}
